import {apiClient} from '@common/http/query-client';

type SyncTitleTmdbImdb = {
  tmdbId: number;
  type: string;
};

const syncGenre = (data: SyncTitleTmdbImdb) => {
  return apiClient.post('sync/tmdb/title/genres', data).then(res => res.data);
};

const syncKeywords = (data: SyncTitleTmdbImdb) => {
  return apiClient.post('sync/tmdb/title/keywords', data).then(res => res.data);
};

const syncTrailers = (data: SyncTitleTmdbImdb) => {
  return apiClient.post('sync/tmdb/title/trailers', data).then(res => res.data);
};

const syncImages = (data: SyncTitleTmdbImdb) => {
  return apiClient.post('sync/tmdb/title/images', data).then(res => res.data);
};

const syncProductionCountry = (data: SyncTitleTmdbImdb) => {
  return apiClient
    .post('sync/tmdb/title/productionCountry', data)
    .then(res => res.data);
};

const syncPosterBackdrop = (data: SyncTitleTmdbImdb) => {
  return apiClient
    .post('sync/tmdb/title/posterBackdrop', data)
    .then(res => res.data);
};

type SyncTitleTmdb = {
  tmdbId: number;
};

const syncPosterTmdb = (data: SyncTitleTmdb) => {
  return apiClient.post('sync/tmdb/person/poster', data).then(res => res.data);
};

const syncGalleryTmdb = (data: SyncTitleTmdb) => {
  return apiClient.post('sync/tmdb/person/gallery', data).then(res => res.data);
};

type SyncPersonImdbType = {
  imdbId: string;
  type: string;
};

const syncPosterBackdropImdb = (data: SyncPersonImdbType) => {
  return apiClient
    .post('sync/imdb/title/posterBackdrop', data)
    .then(res => res.data);
};

const syncCreditImdb = (data: SyncPersonImdbType) => {
  return apiClient.post('sync/imdb/title/credits', data).then(res => res.data);
};

type SyncPersonImdb = {
  imdbId: string;
};

const syncPosterImdb = (data: SyncPersonImdb) => {
  return apiClient.post('sync/imdb/person/poster', data).then(res => res.data);
};

const syncGalleryImdb = (data: SyncPersonImdb) => {
  return apiClient.post('sync/imdb/person/gallery', data).then(res => res.data);
};

const syncPerson = (id:number) => {
  return apiClient.get(`sync/imdb/person/data/${id}`);
}

type TranslateWithIds = {
  model: string;
  ids: number[];
};

const translateTitleName = (data: TranslateWithIds) => {
  return apiClient.post('sync/chatgpt/title/name', data).then(res => res.data);
};

const translateTitleDescription = (data: TranslateWithIds) => {
  return apiClient
    .post('sync/chatgpt/title/description', data)
    .then(res => res.data);
};

const translateTitleTagline = (data: TranslateWithIds) => {
  return apiClient
    .post('sync/chatgpt/title/tagline', data)
    .then(res => res.data);
};

const translatePersonName = (data: TranslateWithIds) => {
  return apiClient.post('sync/chatgpt/person/name', data).then(res => res.data);
};

const translatePersonBio = (data: TranslateWithIds) => {
  return apiClient
    .post('sync/chatgpt/person/description', data)
    .then(res => res.data);
};

const translatePersonBirthPlace = (data: TranslateWithIds) => {
  return apiClient
    .post('sync/chatgpt/person/birthPlace', data)
    .then(res => res.data);
};

type TranslateWithId = {
  model: string;
  id: number;
};

const translateCredit = (data: TranslateWithId) => {
  return apiClient
    .post('sync/chatgpt/title/credit', data)
    .then(res => res.data);
};

export {
  translateCredit,
  translatePersonBio,
  translatePersonBirthPlace,
  translatePersonName,
  translateTitleDescription,
  translateTitleName,
  translateTitleTagline,
  syncCreditImdb,
  syncGalleryImdb,
  syncGalleryTmdb,
  syncGenre,
  syncImages,
  syncKeywords,
  syncPosterBackdrop,
  syncPosterBackdropImdb,
  syncPosterImdb,
  syncPosterTmdb,
  syncProductionCountry,
  syncTrailers,
  syncPerson,
};
